import React from 'react';
import { Col, Container, Row, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'react-calendar/dist/Calendar.css';
import Katbookpowerlist from './Katbookpowerlist';
import KatbookTabs from './KatbookTabs';
import EnquirePopupFrom from '../../../Components/EnquirePopupFrom';
import TalktoExpert from '../TalktoExpert';
import BookaDemo from '../BookaDemo';

const Katbook = () => {
    const [modalShow, setModalShow] = React.useState(false);
    const [shadow, setShow] = React.useState();
    const [showUteach, setShowUteach] = React.useState(false);
    const [showUlearn, setShowUlearn] = React.useState(false);

    return (
        <div className="KatbookPage">
            <section className='InnerPBanSec'>
                <div className='IPBBgimg'>
                    <img src={require('../../../asstes/images/katbookBanBg.jpg')} alt="" />
                </div>
                <div className='BanContSec'>
                    <Container>
                        <div className='textBlack'>
                            <h5 className='textright tbheadFive tbHeadLeft'>Revolutionary format of
                                <br />Digital Books </h5>
                            <h1>KADBOOK</h1>
                            <h5 className='tbheadFive tbHeadRight'>The Collaborative Advanced Digital Book
                                {/* <br />Digital Book */}
                            </h5>
                        </div>
                    </Container>
                </div>
            </section>
            <section className='ProIntroSec'>
                <div className='ProContSec ktbkIntroC'>
                    <Container>
                        <div className='textBlack tbTitle'>
                            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                <h2 style={{ fontSize: '40px' }} data-aos="fade-down" data-aos-duration="1000">Welcome to <span style={{ fontSize: '60px' }}>UTEACH </span> and <span style={{ fontSize: '60px' }}>ULEARN</span><br></br> in <span style={{ fontSize: '60px' }}>KADBOOK</span>   format</h2></div>
                            <h4 style={{ fontSize: '35px', marginTop: '10px' }} data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">
                                Our comprehensive Solution to Your Digital Teaching and Learning needs</h4>
                            <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="200">They combine the power of enhanced content on <span style={{ color: '#3ab2cb' }}>Keywords, 3D models, concept videos, explanation videos, virtual labs, lesson plans,
                                in-book clarification tool, integration of AI, translator, and multiple cutting edge digital tools </span>with the convenience of anywhere, anytime access. KADBOOK format revolutionizes the method
                                of teaching and learning, making it simple and effective with integrated communication support. With UTEACH, educators can teach effortlessly, effectively, engaging the class with the interactive content. With ULEARN, students can learn at their own pace, engaging with the interactive content and
                                collaborating with fellow learners. ULEARN empowers students to connect with teaching faculty,
                                facilitating personalized guidance and support throughout their educational journey

                            </p>
                        </div>

                        <div className='textBlack ktbkList'>
                            <ul>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="300"><img src={require('../../../asstes/images/KbookIntroIconOne.svg').default} alt="360-degree additional information on all Keywords" /><strong>360-degree additional<br /> information on<br /> all Keywords.</strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="400"><img src={require('../../../asstes/images/KbookIntroIconTwo.svg').default} alt="Sliced concept and teaching videos embedded within sessions" /><strong>Sliced concept and<br /> teaching videos <br />embedded within <br />sessions. </strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="500"><img src={require('../../../asstes/images/KbookIntroIconThree.svg').default} alt="In-book doubt clearing and collaboration mechanism" /><strong>In-book doubt<br /> clearing and <br />collaboration<br /> mechanism. </strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="600"><img src={require('../../../asstes/images/KbookIntroIconFour.svg').default} alt="Enhanced features bridge the gap between digital and tangible reading experiences" /><strong>Integration of cutting<br /> edge digital tools bridge<br />the gap between digital  <br />and tangible reading <br />  experiences</strong></li>
                            </ul>
                            <ul>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="700"><img src={require('../../../asstes/images/KbookIntroIconFive.svg').default} alt="Offline, Online, and hybrid modes of the book are available" /><strong>Online, and hybrid <br />modes of the UTEACH <br /> and ULEARN content <br />are available.</strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="800"><img src={require('../../../asstes/images/KbookIntroIconSix.svg').default} alt="Provision to raise doubts from all parts of the textbook/learning material." /><strong>Provision to seek <br />clarifications from all <br />parts of the main<br />text content, Keyword<br /> content and videos.</strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="900"><img src={require('../../../asstes/images/KbookIntroIconSeven.svg').default} alt="Notification of the clarification sought to all stakeholders." /><strong>Visibility of <br />the clarification sought <br />to the teacher and <br /> other students of the class. </strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="1000"><img src={require('../../../asstes/images/KbookIntroIconEight.svg').default} alt="FAQ from previous doubts raised " /><strong>FAQ from previous<br /> doubts can be created.  </strong></li>

                            </ul>
                        </div>
                        <div className='textBlack ktbkYTDiv'>
                            <Link to=''><img src={require('../../../asstes/images/ktbkIntroYTIcon.png')} alt='KADBOOK You Tube' /></Link>
                        </div>
                    </Container>
                </div>
            </section>
            <section className='ProFeatuSec'>
                <Container>
                    <div className='textBlack tbTitle textCenter'>
                        <h2 data-aos="fade-down" data-aos-duration="1000">Unique Features of<br /> <span>KADBOOK</span> format</h2>
                        <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">Unmatched Features making the Teaching and Learning complete</p>
                    </div>
                    <div className='textBlackrow'>
                        <Row>
                            <Col>
                                <div className='featboxitems fbitemOne'>
                                    <div className='featboximg'>
                                        <img src={require('../../../asstes/images/ktbkFeatboxImg1.png')} alt="KADBOOK Feature" />
                                        <h3>UTEACH</h3>
                                        <p style={{
                                            margin: '0', marginTop: '5px', position: 'absolute', top: '46%', right: '6%', fontWeight: '400', fontSize: '18px', lineHeight: '1', letterSpacing: '-1px', color: '#fff', textTransform: 'uppercase'
                                        }}>
                                            Our Solution for <span style={{ fontWeight: '600', fontSize: '25px' }}>Teachers</span></p>
                                    </div>
                                    <div className='featboxpara'>
                                        <p>UTEACH content in KADBOOK format serves as a comprehensive solution for all teachers. With identified keywords, additional relevant content is readily made available, teachers need not search the internet for further information. The concept videos are seamlessly integrated into each session of the book, eliminating the need to search for suitable videos elsewhere.</p>
                                        <p>Furthermore, Lesson plans are made available which is the essential instructional roadmap that directly enhances the teacher's efficiency, confidence, and classroom control. Teachers can upload their own content and show as part of KADBOOK while teaching.</p>
                                        <button type="button" className="viewMoreBtn" onClick={() => setShowUteach(true)}>
                                            View More
                                        </button>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className='featboxitems fbitemTwo'>
                                    <div className='featboximg'>
                                        <img src={require('../../../asstes/images/ktbkFeatboxImg2.png')} alt="KADBOOK Feature" />
                                        <h3>ULEARN</h3>
                                        <p style={{
                                            margin: '0', marginTop: '5px', position: 'absolute', top: '46%', right: '6%', fontWeight: '400', fontSize: '18px', lineHeight: '1', letterSpacing: '-1px', color: '#fff', textTransform: 'uppercase'
                                        }}>
                                            Our Solution for <span style={{ fontWeight: '600', fontSize: '25px' }}>Students</span></p>
                                    </div>
                                    <div className='featboxpara'>
                                        <p>ULEARN content in KADBOOK format serves as a complete solution for all students. With identified Keywords, Concept videos, Explanation videos, 3D models and videos, Virtual labs readily made available, students need not search the internet for further information. This content is seamlessly integrated into each session of the book, eliminating the need to search for suitable videos elsewhere. </p>
                                        <p>Furthermore, the study material and self-assessments with adaptive learning  directly enhances the student's confidence and conceptual understanding with clarity on the improvements needed to perform well.</p>
                                        <button type="button" className="viewMoreBtn" onClick={() => setShowUlearn(true)}>
                                            View More
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>
            <section className='ProAIPowSec '>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className='textBlack tbTitle'>
                                <h4 data-aos="fade-down" data-aos-duration="1000">Elevate Your Teaching and Learning with</h4>
                                <h2 data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">Kadbook's AI-Powered <small>Educational Solutions</small></h2>
                                <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="300">What’s included in KADBOOK format, our holistic gateway to a great education?</p>
                            </div>
                        </Col>
                        <Col md={9} className='ProAIPowSCol katbokAipow'>
                            <Katbookpowerlist />
                            <div className='ProAIPowIMg'><img src={require('../../../asstes/images/ProAIPow.png')} alt="KADBOOK's AI-Powered" /></div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Modal show={showUteach} onHide={() => setShowUteach(false)} size="xl" centered scrollable dialogClassName="uCardModal">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <section className='Uteach' id='uteachDetail'>
                        <div>
                            {/* <img style={{ width: '8%'}} src={require('../../../asstes/images/Uteach.jpg')} alt="" /> */}

                            <div className='UteachTitle'>
                                <span data-aos="fade-down" data-aos-duration="1000" style={{ color: '#3ab2cb' }} >UTeach</span>
                                <span data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100" style={{ color: '#000000' }} >- Enhanced Teaching content from Kakumanu</span>

                            </div>


                            <Row>
                                <Col xs={12}>
                                    <div>
                                        <p style={{ textAlign: 'center' }}>UTeach is an enhanced teaching content in <span style={{ color: '#2b9fb7', fontWeight: 'bold' }}>KADBOOK</span>  format that enables
                                            effortless lesson delivery. Fully aligned with all curricula, it ensures effective
                                            and engaging classroom experience.</p>
                                    </div>
                                </Col>
                            </Row>

                            <div className='UteachList'>

                                <div>
                                    <h5>Our enhanced content consists of</h5>
                                    <ol>
                                        <li>Ice breaker activities</li>
                                        <li>Detailed explanation for Keywords</li>
                                        <li>2D & 3D concept videos</li>
                                        <li>Explanation videos</li>
                                        <li>3D models for enhanced explanations</li>
                                        <li>Lesson Plans</li>
                                        <li>Quizzes & interactive exercises</li>
                                        <li>Q & A with solutions</li>
                                        <li>Teacher’s manual</li>
                                    </ol>
                                </div>

                                <div>
                                    <h5>KADBOOK – Features </h5>
                                    <ol>
                                        <li>Notes</li>
                                        <li>Bookmarks</li>
                                        <li>Hyperlinks</li>
                                        <li>Highlights</li>
                                        <li>RAG AI & Generative AI </li>
                                        <li>Read Aloud (Text-to-Speech)</li>
                                        <li>DET -Dictionary, Encyclopedia, Translator</li>
                                        <li>Upload & showcase teacher’s own content</li>
                                    </ol>
                                </div>
                            </div>
                            <Row>
                                <Col xs={12}>
                                    <div>
                                        <h5><span style={{ color: 'rgb(43, 159, 183)', fontWeight: 'bold' }}>UTeach</span> supports multiple curriculums </h5>
                                        <p>We have enhanced content with question banks and solutions in KADBOOK
                                            format from leading content providers for the following curriculums<br />
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '25px', fontSize: '14px', fontWeight: '600', color: '#000000', marginTop: '20px' }}>
                                                <span>• CBSE</span>
                                                <span>• All State Boards</span>
                                                <span>• ICSE</span>
                                                <span>• IB</span>
                                                <span>• Cambridge</span>
                                                <span>• International STEM</span>
                                            </div>
                                        </p>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12}>
                                    <div>
                                        <h5 style={{ fontSize: '24px', marginBottom: '20px' }}>Virtual Labs in <span style={{ color: '#2b9fb7', fontWeight: 'bold' }}>KADBOOK</span> </h5>
                                        <h2 >Hands-on Learning without Boundaries</h2>
                                        <p>Virtual Labs in KADBOOK enable teachers to teach real-world experiments
                                            through interactive digital simulations anytime, anywhere without the need
                                            for physical labs. It delivers safe, repeatable, and engaging hands-on learning
                                            with real-time results, helping students clearly connect theory with practical
                                            understanding. </p>
                                        <h2 style={{ marginTop: '20px' }}>Key Benefits</h2>
                                        <ul className="kbBenefits">
                                            <li>Enhances conceptual clarity</li>
                                            <li>Supports self-paced learning</li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12}>
                                    <div>
                                        <h5 style={{ fontSize: '24px', marginBottom: '20px' }}>Interactive Activities in <span style={{ color: '#2b9fb7', fontWeight: 'bold' }}>KADBOOK</span></h5>
                                        <h2>Active Learning, Better Understanding </h2>
                                        <p>Interactive activities in KADBOOK transform traditional teaching into a
                                            dynamic, hands-on experience making lessons more engaging and effective
                                            while reinforcing student learning through meaningful practice.</p>
                                        <h2 style={{ marginTop: '20px' }}>Key Benefits</h2>
                                        <ul className="kbBenefits">
                                            <li>Boosts student engagement and participation</li>
                                            <li>Enhances retention through practical learning</li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>

                        </div>
                    </section>
                </Modal.Body>
            </Modal>
            <Modal show={showUlearn} onHide={() => setShowUlearn(false)} size="xl" centered scrollable dialogClassName="uCardModal">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <section className='Ulearn' id='ulearnDetail'>
                        <div>
                            {/* <img style={{ width: '8%'}} src={require('../../../asstes/images/Ulearn.jpg')} alt="" /> */}
                            <div className='UlearnTitle'>
                                <span data-aos="fade-down" data-aos-duration="1000"
                                    style={{ color: '#3ab2cb' }}>ULearn</span>
                                <span data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100"
                                    style={{ color: '#000000' }}>- Enhanced learning content from Kakumanu</span>

                            </div>

                            <Row>
                                <Col xs={12}>
                                    <div>
                                        <p style={{ textAlign: 'center' }}>ULearn is an enhanced digital learning content in <span style={{ color: '#2b9fb7', fontWeight: 'bold' }}>KADBOOK</span>  format, designed
                                            to make student’s learning simple, engaging, and impactful. Fully aligned
                                            with all major curricula, it transforms traditional content into an interactive
                                            experience, enabling students to understand concepts effortlessly and retain
                                            knowledge effectively. </p>
                                    </div>
                                </Col>
                            </Row>

                            <div className='UlearnList'>

                                <div>
                                    <h5>Our enhanced content consists of</h5>
                                    <ol>
                                        <li>Detailed explanation for Keywords</li>
                                        <li>2D & 3D concept videos </li>
                                        <li>Explanation videos</li>
                                        <li>3D models for enhanced explanations</li>
                                        <li>Q & A with solutions</li>
                                        <li>Self-assessment with assisted adaptive learning</li>
                                        <li>Previous year solved question papers</li>
                                        <li>Synopsis and summary for topic-wise quick learning</li>
                                        <li>Mock test and Mock exams from KADBOOK</li>
                                        <li>Interactive activities</li>
                                    </ol>
                                </div>

                                <div>
                                    <h5>KADBOOK – Features </h5>
                                    <ol>
                                        <li>Notes</li>
                                        <li>Bookmarks</li>
                                        <li>Hyperlinks</li>
                                        <li>Highlights</li>
                                        <li>RAG AI & Generative AI </li>
                                        <li>Read Aloud (Text-to-Speech)</li>
                                        <li>DET -Dictionary, Encyclopedia, Translator</li>
                                    </ol>
                                </div>

                            </div>

                            <Row>
                                <Col xs={12}>
                                    <div>
                                        <h5><span style={{ color: 'rgb(43, 159, 183)', fontWeight: 'bold' }}>ULearn</span> supports multiple curriculums</h5>
                                        <p>We have enhanced content with question banks and solutions in KADBOOK
                                            format from leading content providers for the following curriculums<br />
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '25px', fontSize: '14px', fontWeight: '600', color: '#000000', marginTop: '20px' }}>
                                                <span>• CBSE</span>
                                                <span>• All State Boards</span>
                                                <span>• ICSE</span>
                                                <span>• IB</span>
                                                <span>• Cambridge</span>
                                                <span>• International STEM</span>
                                            </div>
                                        </p>
                                    </div>
                                </Col>
                            </Row>

                        </div>
                    </section>
                </Modal.Body>
            </Modal>
            <section className='ProRobSolSec KatbookRobSolSec'>
                <div className='RobSolSlides'>
                    <div className={`RobSolSlide RSSlideOne ${shadow ? "RSSlideLHide" : "RSSlideLOpen"}`}  >
                        <Container>
                            <Row>
                                <Col md={12} >
                                    <div className='textBlack tbTitle titlemBtm'>
                                        <h2 data-aos="fade-down" data-aos-duration="1000"><span>KADBOOK</span> Empowering Institutions<br /> With Robust Solutions</h2>
                                        <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">Isn't it time to revolutionize education?</p>
                                    </div>
                                </Col>
                                <Col md={6} className='ProRobLcol'>
                                    <img src={require('../../../asstes/images/KBRobSolImgss.png')} alt="Robust Solutions " />
                                    <p className='exprbtn'><Link to="#" onClick={() => setModalShow(true)} className=''>enquire now</Link></p>
                                </Col>
                                <Col md={6} className='ProRobRcol'>
                                    <div className='RobSolItems'>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon1.svg').default} alt="" />
                                            <h4>Growth-Oriented<br /> Platform</h4>
                                            <p>Scalable and<br /> High-Quality<br /> for All Stakeholders.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon2.svg').default} alt="" />
                                            <h4>Accessible to<br /> All Stakeholders</h4>
                                            <p>Students, Teachers,<br /> Administrators, and<br /> Parents.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon3.svg').default} alt="" />
                                            <h4>Multi-Platform Availability</h4>
                                            <p>Web, Android, and<br /> iOS Support.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon4.svg').default} alt="" />
                                            <h4>Cost-Effective</h4>
                                            <p>Solution for<br /> Institutions and<br /> Students.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon5.svg').default} alt="" />
                                            <h4>Accessibility</h4>
                                            <p>KADBOOK is accessible <br /> On-Site or via the <br /> Cloud Platform.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon6.svg').default} alt="" />
                                            <h4>Versatile Usage<br /> across Devices</h4>
                                            <p>Laptops/Desktops,<br /> Digital Tablets,<br /> Mobile Phones.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon8.svg').default} alt="" />
                                            <h4>Institution<br /> Managed Book<br /> Authoring</h4>
                                            <p>Self-Contained<br /> Tool to create <br />school-managed book.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon7.svg').default} alt="" />
                                            <h4>Affordable<br /> World-Class Platform</h4>
                                            <p>On Campus, Off Campus<br /> & Hybrid Teaching.</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                        <div className='RobSolSlideLink'><button to='/' className='linkbtn' onClick={() => setShow(true)}><strong>Corporate</strong> <img src={require('../../../asstes/images/LineArrowRight.svg').default} alt="" /></button></div>
                    </div>
                    <div className={`RobSolSlide RSSlideTwo ${shadow ? "RSSlideROpen" : "RSSlideRHide"}`} >
                        <Container>
                            <Row>
                                <Col md={12} >
                                    <div className='textBlack tbTitle titlemBtm'>
                                        <h2 data-aos="fade-down" data-aos-duration="1000"><span>KADBOOK</span> Scalable solutions for the training needs of your organization</h2>
                                        <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">Isn't it time to revolutionize education?</p>
                                    </div>
                                </Col>
                                <Col md={6} className='ProRobLcol'>
                                    <img src={require('../../../asstes/images/KBRobSolImgOne.jpg')} alt="Robust Solutions " />
                                    <p className='exprbtn'><Link to="#" onClick={() => setModalShow(true)} className=''>enquire now</Link></p>
                                </Col >
                                <Col md={6} className='ProRobRcol'>
                                    <div className='RobSolItems'>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon9.svg').default} alt="" />
                                            <h4>Empowering Lifelong<br /> Learning</h4>
                                            <p>Upskilling for All<br /> in the Organization<br /> is enabled as per requirement.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon10.svg').default} alt="" />
                                            <h4>Flexible Learning</h4>
                                            <p>Overcomes the <br />constraints of time <br />and availability with <br />Online, Offline, and <br />Hybrid Modes to <br />suit the needs. </p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon11.svg').default} alt="" />
                                            <h4>Skill Development on Schedule</h4>
                                            <p>A periodic training calendar be generated to assess growth and success.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon12.svg').default} alt="" />
                                            <h4>Empowered Self-Assessment</h4>
                                            <p>Post-course assessment and report generation<br /> for each course shall be <br />made available. </p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon13.svg').default} alt="" />
                                            <h4>Validate Your Achievements</h4>
                                            <p>Certification Upon Assessment Completion<br /> of a specific course <br />attended and be <br />generated. </p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon14.svg').default} alt="" />
                                            <h4>Comprehensive Training Reports</h4>
                                            <p>Admin-Generated Insights are made available on training attendees, course completed, the course in progress, assessments, etc for every Organization.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon15.svg').default} alt="" />
                                            <h4>Seamless Integration</h4>
                                            <p>Monitoring of attendance<br /> to training and Course <br />Progress with any<br /> ERP can be enabled.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon16.svg').default} alt="" />
                                            <h4>Equal Learning Opportunities</h4>
                                            <p>Empowering corporate workforce by overcoming faculty availability constraints.
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                        <div className='RobSolSlideLink'><button to='#' className='linkbtn' onClick={() => setShow(false)}><strong>Institutions </strong> <img src={require('../../../asstes/images/LineArrowRight.svg').default} alt="" /></button></div>
                    </div>
                </div>
            </section>
            <section className='ProApplinkSec'>
                <Container>
                    <div className='textBlack tbTitle'>
                        <h4 data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100">Get your <br /><span className='colorchange'>K</span>ollaborative <br /><span className='colorchange'>A</span>dvanced <br /><span className='colorchange'>T</span>ext<span className='colorchange'>book</span> NOW!</h4>
                        <ul data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100">
                            <li><Link to='https://www.katbookstore.com/' target='_blank'><img src={require('../../../asstes/images/digital-katebook-img.png')} alt="digital-katebook-img" /></Link></li>
                            <li><Link to='#'><img src={require('../../../asstes/images/GPlayImg.webp')} alt="Google Play" /></Link></li>
                            <li><Link to='#'><img src={require('../../../asstes/images/AppStoreImg.webp')} alt="App Store" /></Link></li>
                        </ul>
                    </div>
                    <div className='applinkdiv'><img src={require('../../../asstes/images/proAppLinkImg.png')} alt="App Link" /></div>
                </Container>
            </section>
            <section className='WChoKBSec'>
                <Container>
                    <div className='textBlack tbTitle textCenter titlemBtm'>
                        <h2 data-aos="fade-down" data-aos-duration="1000">Why Choose <span>KADBOOK?</span></h2>
                        <h4 data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">Unveiling the Benefits</h4>
                        <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="200">Where the stakeholders thrive together through seamless collaboration and<br /> transformative benefits.</p>
                    </div>
                    <div className='WCHooTab'>
                        <KatbookTabs />
                    </div>
                </Container>
            </section>
            {/* <section className='HoldonSec'>
                <Container>
                    <div className='textBlack tbTitle textCenter titlemBtm'>
                        <h2 data-aos="fade-down" data-aos-duration="1000"><span>Hold On</span></h2>
                        <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">did you try our demo ?</p>
                    </div>
                    <div className='honInROw'>
                        <Row>
                            <Col md='6' className='honCol honColL'>
                                <div className='HoFromCont'>
                                    <h4>Talk To An Expert</h4>
                                    <TalktoExpert />
                                </div>
                            </Col>
                            <Col md='6' className='honCol honColR'>
                                <div className='HoCalen'>
                                    <BookaDemo />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section> */}
            <EnquirePopupFrom show={modalShow} onHide={() => setModalShow(false)} />
        </div>
    )
}

export default Katbook